import { geoDist } from './geo';

const MIRRORS = ['https://overpass-api.de/api/interpreter', 'https://overpass.kumi.systems/api/interpreter', 'https://maps.mail.ru/osm/tools/overpass/api/interpreter'];

// huts and drinking water within `radius` m of a route (Overpass "around" a polyline), ordered along the route
export async function routeStops(pts, radius = 1000) {
  const step = Math.max(1, Math.ceil(pts.length / 60)), line = pts.filter((_, i) => i % step === 0 || i === pts.length - 1);
  const ll = line.map(([a, b]) => `${a.toFixed(5)},${b.toFixed(5)}`).join(',');
  const q = `[out:json][timeout:25];(nwr["tourism"~"alpine_hut|wilderness_hut"](around:${radius},${ll});nwr["amenity"="drinking_water"](around:${radius},${ll});nwr["amenity"="shelter"](around:${radius},${ll}););out center 80;`;
  let r = null;
  for (const ep of MIRRORS) {
    try {
      const ctl = new AbortController(), id = setTimeout(() => ctl.abort(), 25000);
      r = await (await fetch(ep, { method: 'POST', body: `data=${encodeURIComponent(q)}`, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, signal: ctl.signal })).json();
      clearTimeout(id);
      if (r?.elements) break;
    } catch { /* next mirror */ }
  }
  if (!r?.elements) throw new Error('overpass');
  const cum = [0];
  for (let i = 1; i < pts.length; i++) cum.push(cum[i - 1] + geoDist(pts[i - 1], pts[i]));
  return r.elements.map((e) => {
    const p = [e.lat ?? e.center?.lat, e.lon ?? e.center?.lon], tg = e.tags || {};
    let bi = 0, bd = Infinity;
    for (let i = 0; i < pts.length; i += Math.max(1, Math.floor(pts.length / 400))) { const d = geoDist(p, pts[i]); if (d < bd) { bd = d; bi = i; } }
    const kind = tg.amenity === 'drinking_water' ? 'water' : tg.amenity === 'shelter' ? 'shelter' : 'hut';
    return { id: `st_${e.type}${e.id}`, lat: p[0], lon: p[1], kind, name: tg.name || '', off: Math.round(bd), at: cum[bi] / 1000, ele: tg.ele };
  }).filter((x) => x.lat != null).sort((a, b) => a.at - b.at);
}
export const STOP_ICON = { hut: '🏠', water: '🚰', shelter: '⛺' };
